import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Emergency from "@/pages/Emergency";
import Scenario from "@/pages/Scenario";
import Manuales from "@/pages/Manuales";
import Recursos from "@/pages/Recursos";
import History from "@/pages/History";
import Precios from "@/pages/Precios";
import Pagar from "@/pages/Pagar";
import PagoExito from "@/pages/PagoExito";
import Admin from "@/pages/Admin";
import QuienesSomos from "@/pages/QuienesSomos";
import AvisoPrivacidad from "@/pages/AvisoPrivacidad";
import Terminos from "@/pages/Terminos";
import GlosarioI589 from "@/pages/GlosarioI589";
import ManualesOficiales from "@/pages/ManualesOficiales";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/auth" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/emergency" element={<PrivateRoute><Emergency /></PrivateRoute>} />
            <Route path="/scenario/:scenario" element={<PrivateRoute><Scenario /></PrivateRoute>} />
            <Route path="/manuales" element={<PrivateRoute><Manuales /></PrivateRoute>} />
            <Route path="/recursos" element={<PrivateRoute><Recursos /></PrivateRoute>} />
            <Route path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
            <Route path="/precios" element={<Precios />} />
            <Route path="/pagar" element={<PrivateRoute><Pagar /></PrivateRoute>} />
            <Route path="/pago/exito" element={<PrivateRoute><PagoExito /></PrivateRoute>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/quienes-somos" element={<QuienesSomos />} />
            <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/terminos-y-condiciones" element={<Terminos />} />
            <Route path="/glosario-i589" element={<PrivateRoute><GlosarioI589 /></PrivateRoute>} />
            <Route path="/manuales-oficiales" element={<PrivateRoute><ManualesOficiales /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
